module.exports = __webpack_public_path__ + "img/sec1.e092620f.png";